import connectFormikField from '../connectFormikField/connectFormikField'
import { ComponentProps } from 'react'
import Textarea from '@/redesign/components/Textarea/Textarea'

const FormikTextarea =
  connectFormikField<ComponentProps<typeof Textarea>>(Textarea)

export default FormikTextarea
